import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios, { CancelToken } from "axios";

import { StatusCode } from "api/protocols";
import { GetPrinterAll } from "api/rpc/2024-04/facilityAdmin/facility/printer";

import { showError } from "redux/actions/ui";
import { TPrinter } from "redux/reducers/models/facility";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";
import POSPrinterStatus from "components/posPrinterStatus/POSPrinterStatus";
import DataTable from "../../../../../components/dataTable/DataTable";

export default function Printers() {
  const history = useHistory();
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const [printers, setPrinters] = useState<TPrinter[]>(undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadPrinters(source.token);
    return () => source.cancel();
  }, []);

  async function loadPrinters(token?: CancelToken) {
    if (printers !== undefined) {
      setPrinters(undefined);
    }

    const res = await GetPrinterAll(null, token ? false : true, token);

    if (token && token.reason) {
      return;
    }
    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Error retrieving printers.")));
    }

    setPrinters(res.status !== StatusCode.OK ? [] : res.data);
  }

  const primaryAction = {
    content: t("Download Printer App"),
    action: () => window.open(process.env.REACT_APP_PRINTER_DOWNLOAD_URL, "_blank"),
  };

  return (
    <Page
      title={t("Printers")}
      subtitle={t(
        "Manage printers available for receipt and chit printing. To add or remove a printer, download and use the printer app.",
      )}
      narrow
      primaryAction={primaryAction}
    >
      <POSPrinterStatus />
      <DataTable
        columns={[{ label: t("Title") }, { label: t("Connection Type") }]}
        loading={printers === undefined}
      >
        {printers?.map(printer => (
          <tr
            key={printer.id}
            className="clickable"
            onClick={() => history.push("/admin/settings/printers/" + String(printer.id))}
          >
            <td className="table-cell-text-lead">{printer.title}</td>
            <td>{printer.connection_type === "usb" ? t("USB") : t("Network")}</td>
          </tr>
        ))}
      </DataTable>
    </Page>
  );
}
